import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import api, { formatErr } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { notify } from "@/lib/toast";

export default function Login() {
    const nav = useNavigate();
    const { refresh } = useAuth();
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { phone, password });
            await refresh();
            notify(`Welcome back, ${data.name || "friend"}!`);
            nav("/dashboard");
        } catch (err) {
            notify(formatErr(err) || "Invalid phone or password", "error");
        } finally {
            setLoading(false);
        }
    }

    return (
        <section className="min-h-screen flex items-center justify-center pt-40 pb-16 relative mesh-gradient" data-testid="login-page">
            <div className="max-w-md w-full mx-4">
                <div className="text-center mb-10">
                    <h1 className="font-display font-bold text-3xl mb-2">Welcome Back</h1>
                    <p className="text-gray-400">Login to manage your QR codes & leads</p>
                </div>
                <div className="glass rounded-3xl p-8">
                    <form onSubmit={onSubmit} className="space-y-5">
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">WhatsApp Number</label>
                            <input data-testid="login-phone" type="tel" required value={phone} onChange={(e) => setPhone(e.target.value)}
                                className="input-field w-full px-4 py-3 rounded-xl" placeholder="e.g., 919876543210" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">Password</label>
                            <div className="relative">
                                <input data-testid="login-password" type={showPassword ? "text" : "password"} required value={password} onChange={(e) => setPassword(e.target.value)}
                                    className="input-field w-full px-4 py-3 pr-12 rounded-xl" placeholder="Enter your password" />
                                <button type="button" onClick={() => setShowPassword((s) => !s)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 text-gray-400 hover:text-brand-400 transition-colors"
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    data-testid="login-toggle-password">
                                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                </button>
                            </div>
                        </div>
                        <button data-testid="login-submit" type="submit" disabled={loading}
                            className="btn-primary w-full py-4 rounded-xl text-lg font-semibold mt-4 disabled:opacity-50">
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </form>

                    <div className="mt-6 text-center text-sm text-gray-500">
                        Don't have an account? <Link to="/register" className="text-brand-400 hover:underline">Register here</Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
